import React from 'react'

import { OFImage1, OFImage2, OFImage3 } from '../../../../assets/images/landingV2/guest'
import './styles.scss'
import './responsiveStyles.scss'

function OtherFeatures() {
  return (
    <div className='gl_of'>
      <div className='gl_of__title'>
        <h1>Інші можливості</h1>
      </div>
      <div className='gl_of__info'>
        <div className='gl_of__info_item'>
          <div className='gl_of__info_item_logo'>
            <img src={OFImage1} alt='Image 1' />
          </div>
          <div className='gl_of__info_item_title'>
            <h5>01/</h5>
            <h6>Перегляд кав&apos;ярень, меню та рейтинг</h6>
          </div>
        </div>
        <div className='gl_of__info_item'>
          <div className='gl_of__info_item_logo'>
            <img src={OFImage2} alt='Image 2' />
          </div>
          <div className='gl_of__info_item_title'>
            <h5>02/</h5>
            <h6>Зручна мапа, маршрут до кав&apos;ярні</h6>
          </div>
        </div>
        <div className='gl_of__info_item'>
          <div className='gl_of__info_item_logo'>
            <img src={OFImage3} alt='Image 3' />
          </div>
          <div className='gl_of__info_item_title'>
            <h5>03/</h5>
            <h6>Відгуки про заклад і оцінка барист</h6>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OtherFeatures
